var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{ref:"breadcrumbs",attrs:{"divider":"/","items":_vm.crumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',[_vm._v(" "+_vm._s(_vm.shouldCollapse(item) ? "..." : item.text)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }